import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { DeclineReasonItemDto } from './decline-reason-item.dto';

@Api('api/agentic-cx/decline-reason')
export class DeclineReasonDto extends DtoHasApi {
  id = 0;
  name = '';
  queueIds: number[] = [];
  queues: DeclineReasonItemDto[] = [];
}
